import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import useHttps from '../../../useHttps';
import {
  HttpConfig,
  SuccessHttpResponse,
  ErrorHttpResponse,
} from '../../../../models/https';
import useGetUserData from '../useGetUserData';

const useDeleteExperience = (experienceId: string) => {
  const [loading, setLoading] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const request = useHttps();

  const { getUserData } = useGetUserData();

  const deleteExperience = async () => {
    setLoading(true);
    try {
      const config: HttpConfig = {
        url: `auth-service/users/experiences/${experienceId}`,
        method: 'delete',
      };
      const onSuccess = ({ data }: SuccessHttpResponse<null>) => {
        toast.success('Experience deleted successfully!');
        setLoading(false);
        setDeleted(true);
        getUserData(); // Refresh user data to reflect changes

        return data;
      };

      // Error callback: Show an error toast and reset local state.
      const onError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
          err?.response?.data?.message ?? 'Failed to delete experience'
        );
        setLoading(false);
        setDeleted(false);
        throw err;
      };

      return request(config, onSuccess, setLoading, onError);
    } catch (error) {
      setLoading(false);
      setDeleted(false);
      throw error;
    }
  };

  return { deleted, loading, deleteExperience };
};

export default useDeleteExperience;
